import { render, staticRenderFns } from "./GroupDetailView.vue?vue&type=template&id=dcc3ce06&scoped=true&"
import script from "./GroupDetailView.vue?vue&type=script&lang=js&"
export * from "./GroupDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=dcc3ce06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc3ce06",
  null
  
)

export default component.exports